export class Validator {
  validate({ data, configuration }) : boolean {
    return true;
  }

  // errors for the body except the title
  getError({ data, configuration, i18n }) : Object {
    return {};
  }

  isAnswered({ data, configuration, i18n }) : string | undefined {
    return undefined;
  }
}
